import { frontendURL } from '../../../helper/URLHelper';
import addKnowledge from './addKnowledge/routes';
import viewKnowledge from './viewKnowledge/routes';
import Knowledge from './Knowledge.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/knowledge'),
      name: 'knowledge',
      component: Knowledge,
      meta: {
        permissions: ['administrator', 'restricted'],
      },
      // Router guard to check subscription using cached data
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    },
    ...addKnowledge.routes,
    ...viewKnowledge.routes,
  ],
};
